<template>
  <div class="vi-modal create-note">
    <div class="vi-modal-content">
      <template v-if="!isLoading">
        <div class="close-modal" @click="close">
          <img src="../../assets/icon_clear.svg"/>
        </div>
        <label class="add-note">
          <span class="add-note-label">Add note</span>
          <textarea ref="textarea" rows="6" v-model="note"></textarea>
        </label>
        <div v-if="error" class="error-msg">
          {{error}}
        </div>
        <div class="notes-actions">
          <vi-button :disabled="!this.note" label="Save" size="sm" @click="saveNote"/>
<!--          <vi-button label="Delete note" size="sm" @click="deleteNote"/>-->
        </div>
      </template>
      <loading-logo v-if="isLoading" :autoplay="true"/>
    </div>
  </div>
</template>

<script>
  import ViButton from "../ui/ViButton";
  import LoadingLogo from "../LoadingLogo";
  import {mapState} from 'vuex';

  export default {
    name: 'CreateNote',
    components: {LoadingLogo, ViButton},
    props: {
      currentNote: {
        type: String
      },
    },

    computed: {
      ...mapState({
        notesMap: state => state.notes.notesMap
      }),
      activeNote() {
        return this.notesMap[this.currentNote]
      }
    },

    data: () => ({
      isLoading: false,
      note: null,
      error: null
    }),

    methods: {
      close() {
        this.$store.commit('notes/setCurrentNote', {callSid: null})
      },
      deleteNote() {
        this.note = '';
        this.saveNote()
      },
      saveNote() {
        this.isLoading = true;

        if(!this.activeNote) {
          this.$store.dispatch('notes/saveNote', {callSid: this.currentNote, note: this.note})
            .then(() => {
              setTimeout(() => {
                this.close()
              }, 200)
            })
            .catch(() => {
              this.isLoading = false;
              this.error = 'An error has occurred. Please try again or contact support'
            })
        } else {
          this.$store.dispatch('notes/updateNote', {callSid: this.currentNote, note: this.note})
            .then(() => {
              setTimeout(() => {
                this.close()
              }, 200)
            })
            .catch(() => {
              this.isLoading = false;
              this.error = 'An error has occurred. Please try again or contact support'
            })
        }
      }
    },

    created() {
      this.note = this.activeNote? this.activeNote.note: null
    },
    mounted() {
      this.$refs.textarea.focus()
    }
  }
</script>

<style lang="scss">
  @import "CreateNote";
</style>
